import React from 'react';
import '../../lib/dropdown/dropdown-menu.css';
import Popup from '../../lib/popup/Popup';
import {
	getCanvasEntityDraggableContainerDOMId,
} from '../../services/editor/ui';
import { EditorService } from '../../services/editor';
import {
	getParentCanvasEntity,
} from '@elyx-code/project-logic-tree';
import EntityErrorListItem from '../entity-error/EntityErrorListItem';

export interface ITestMenuValidationDropdownProps {
	project: EditorService;
}

const TestMenuValidationDropdown: React.FC<ITestMenuValidationDropdownProps> = (
	props
) => {
	const resolveValidationHeaderText = (): string => {
		if (props.project.test.validation.length > 0) {
			// Set errors on the specific fields that are missing values
			// Return the reason why the test is invalid
			return `${props.project.test.validation.length} logic error${
				props.project.test.validation.length > 1 ? 's' : ''
			} found in the nodes covered by this execution`;
		}
		return '';
	};

	return (
		<Popup
			anchorQuerySelector='#play-test-button'
			closeDelay={400}
			arrowClasses={['dropdown-menu-card-arrow']}
			placement='top'
			open
		>
			<div className='dropdown-menu-card'>
				<header
					style={{
						padding: '10px 20px',
						borderBottom: '1px solid #e0e0e0',
						fontWeight: 400,
						fontSize: '14px',
						color: 'var(--color-main-grey)',
					}}
				>
					{resolveValidationHeaderText()}
				</header>
				<ul
					className='entity-error__results'
					style={{ width: '100%' }}
					onScroll={(e: any) => {
						e.stopPropagation();
						document.body.style.overflow = 'hidden';
					}}
				>
					{props.project.test.validation.map((error) => (
						<EntityErrorListItem
							error={error}
							onClick={() => {
								// If the zoom is too small, zoom in to the entity
								if (props.project.canvas?.currentScale < 0.7) {
									props.project.canvas?.zoomTo(0.7);
								} else if (props.project.canvas?.currentScale > 1) {
									props.project.canvas?.zoomTo(1);
								}

								const canvasEntity = getParentCanvasEntity(error.entity);

								props.project.canvas?.scrollToObjectById(
									getCanvasEntityDraggableContainerDOMId(canvasEntity)
								);
							}}
						/>
					))}
				</ul>
			</div>
		</Popup>
	);
};

export default TestMenuValidationDropdown;
